// Auto-generated normalizer for table: E_Mail
export function eMailNormalize(row) {
  return {
    idCorreo: row.idCorreo ?? row.IdCorreo ?? row['IdCorreo'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    correo: row.correo ?? row.Correo ?? row['Correo'] ?? '',
    esPrincipal: row.esPrincipal ?? row.EsPrincipal ?? row['EsPrincipal'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
